export const Bio = {
  name: "Aditya Singh",
  roles: [
    "Full Stack Developer",
    "Mobile App Developer",
    "Programmer",
  ],
  description:
    "Motivated, adaptable, and committed to excellence, I bring a positive attitude and a growth mindset to every challenge. Ready to make a meaningful impact and achieve success.",
  github: "https://github.com/lookthisisaddy",
  resume:
    "",
  linkedin: "https://www.linkedin.com/in/adityasingh24/",
  twitter: "https://twitter.com/lookthisisaddy",
  insta: "https://www.instagram.com/lookthisisaddy/"
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      // {
      //   name: "Java",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      // },
      // {
      //   name: "Spring Boot",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Spring_Boot.svg/180px-Spring_Boot.svg.png",
      // },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "SAP BTP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/SAP_2011_logo.svg/2560px-SAP_2011_logo.svg.png",
      },
      {
        name: "GCP",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      }
    ],
  },
  {
    title: "Mobile App",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Dart",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Dart_programming_language_logo_icon.svg/2048px-Dart_programming_language_logo_icon.svg.png",
      }
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fdeloitte_logo.png?alt=media&token=b4b03c3a-4d0a-4303-9b3e-e0cdb7bb1222",
    role: "Analyst",
    company: "Deloitte Touche Tohmatsu India LLP",
    date: "June 2022 - Present",
    desc: "Translated project requirements into code, serving as a proficient full-stack developer skilled in both front-end and back-end technologies. Led feature development, ensuring the application of best practices throughout. Developed a comprehensive web application for enterprise shift scheduling, resulting in a 40% reduction in scheduling time and a notable improvement in employee satisfaction due to smoother processes and enhanced flexibility. Leveraged React.js, Bootstrap, and JavaScript to create responsive and interactive UI components, ensuring a seamless and engaging user experience. Implemented advanced features like dynamic routing, form validations, and custom hooks. Utilized Redux to handle complex application states. On the backend, used Node.js, Express, and Mongoose to build efficient and scalable REST APIs. Designed RESTful endpoints to handle CRUD operations. JWT for user-authentication, applied middleware for logging, error handling, and request validation to maintain a robust and secure application infrastructure. Focused on optimizing performance through code-splitting, lazy loading, and implementing best practices for both front-end and back-end development. Created technical documentation and provided training to ensure smooth on boarding of staff and effective knowledge transfer. Partook in the team’s agile software development process; developed unit tests and functional/integration tests; supported production deployments of developed solutions. ",
    skills: [
      "NodeJS",
      "JavaScript",
      "ReactJS",
      "Java",
      "SAP BTP",
      "Cloud Foundry",
      "HTML",
      "CSS"
    ]
    //doc: "",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fmicroficial_logo.jpg?alt=media&token=8b82fea8-76df-4e07-8eb7-41e99007b0a8",
    role: "Internship - Android Developer",
    company: "Microficial Intelligence",
    date: "Feb 2021 - Jun 2021",
    desc: "During the third year of college, contributed to Android app development as an intern. Tasked with creating and maintaining Android apps, utilized Java, collection frameworks, and multi-threading techniques. Implemented Android UI best practices and material design for visually appealing layouts with intuitive navigations. Integrated Firebase for real-time data sync and authentication, alongside diverse APIs for location services and social sharing functionalities.",
    skills: [
      "Java",
      "Android",
      "Material UI",
      "Google Maps Platform",
      "Firebase"
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fmicro_intern_cert.png?alt=media&token=03e2ee00-6be7-4f2d-913b-d0a4b0894b6e",
  }
];

export const education = [
  
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fvjti_logo.jpg?alt=media&token=a8eb3a03-bf8a-4af3-acf0-e9f956efbeac",
    school: "Veermata Jijabai Technological Institute, Mumbai",
    date: "May 2018 - May 2022",
    grade: "7 CGPA",
    desc: "I completed my Bachelor's degree in Electronics Engineering at Veermata Jijabai Technological Institute, Mumbai.",
    degree: "Bachelor of Technology - Electronics Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fdav_logo.png?alt=media&token=37cfc1a9-c38b-469a-93c3-a344be2d914c",
    school: "DAV Public School, New Panvel",
    date: "May 2015 - May 2017",
    grade: "89%",
    desc: "I completed my class 12 high school education at DAV Public School, New Panvel, where I studied Science with Informatics Practices.",
    degree: "CBSE(XII), Science with IP",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fmes_logo.jpg?alt=media&token=1816e220-6d56-4ba9-ba46-9c6991d77911",
    school: "Mahatma Education Society, New Panvel",
    date: "May 2010 - May 2015",
    grade: "91%",
    desc: "I completed my class 10 education at MES School, New Panvel.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "Shopping Website",
    date: "Mar 2024 - Mar 2024",
    description:
      "Built an e-commerce platform using the MERN stack, ensuring a seamless user journey from product search to order tracking. Developed the front end using React.js & HTML/CSS to create responsive and dynamic UI components. Implemented the admin panel functionality by integrating features for adding new products.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Fshopper.png?alt=media&token=d137827a-393c-4898-875b-28cc40790315",
    tags: ["React.js", "HTML5", "CSS", "NodeJs", "Express", "Javascript", "JWT", "MongoDB"],
    category: "web app",
    github: "https://github.com/lookthisisaddy/ShoppingWebsite",
    webapp: "https://myshopperwebsite.netlify.app/"
  },
  {
    id: 1,
    title: "YouCool - A Youtube Clone",
    date: "Feb 2024 - Feb 2024",
    description:
      "Developed a front-end clone of YouTube using React, designed to deliver an ad-free viewing experience. The project focuses on replicating YouTube's core functionalities, including user interface, video playback, related videos, and comments, to provide a seamless and familiar user experience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Flivdemo.gif?alt=media&token=00f0e1c7-8e81-4a9e-a83a-71e4886b669f",
    tags: ["React.js", "HTML5", "CSS", "Youtube API", "Google Cloud Console", "Javascript"],
    category: "web app",
    github: "https://github.com/lookthisisaddy/YouCool",
    webapp: "https://myyoucool.netlify.app/"
  },
  {
    id: 2,
    title: "Trello Clone",
    date: "April 2024 - April 2021",
    description:
      "A Trello frontend clone built using React, styled with Bootstrap and has drag-and-drop features thanks to react-beautiful-dnd. This platform enables the creation of task lists, facilitating efficient tracking in a user-friendly and intuitive UI.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Ftrello_demo.gif?alt=media&token=41fe9eb6-431d-4395-98fd-b85891dac168",
    tags: ["React.js", "HTML5", "CSS", "Bootstrap 5", "Javascript", "react-beautiful-dnd"],
    category: "web app",
    github: "https://github.com/lookthisisaddy/Trello",
    webapp: "https://mytrelloapp.vercel.app/"
  },
  {
    id: 3,
    title: "Location Guide - Google Maps Clone",
    date: "Apr 2021 - Jun 2021",
    description:
      "Developed a Java-based Android app that seamlessly integrates Google Maps API for efficient location-based interactions, similar to G-Maps. Utilizing the device's GPS, users can instantly locate themselves and explore nearby places such as restaurants, hotels, ATMs, and tourist attractions within a 1.5-kilometer radius. The app also enables country-wide place searches. Leveraging Google Maps Platform APIs like Places API and Directions API, users can access detailed place information and routes.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Floc_guide_home.png?alt=media&token=84653d3e-a169-4e6f-ae7b-ba45b6577f92",
    tags: ["Java", "Android", "Google Maps SDKs", "XML", "Firebase", "Material UI"],
    category: "android app",
    github: "https://github.com/lookthisisaddy/Location-Guide",
    webapp: ""
  },
  {
    id: 4,
    title: "Frutsh",
    date: "Apr 2021 - Jun 2021",
    description:
      "Developed an Android application designed to provide real-time updates on the freshness status of fruits. Leveraging web scraping techniques, the app retrieves HTML data from designated websites via their URLs. Through advanced parsing algorithms, it extracts vital attributes such as fruit name, condition, image URLs, and upload timestamps from the HTML content. This innovative approach ensures users receive accurate and timely information about the freshness of various fruits, enhancing their overall shopping experience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/my-portfolio-15773.appspot.com/o/images%2Ffrutsh-demo.gif?alt=media&token=b32101bf-230e-4ed3-aaa7-5930966aa5b6",
    tags: ["Java", "Android", "Web Scraping", "XML", "HTML"],
    category: "android app",
    github: "https://github.com/lookthisisaddy/Location-Guide",
    webapp: ""
  },
  
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
